import Vue from 'vue'
import Utils from './Utils'
import Auth from './Auth'
export default {
  url: Auth.getUrl('email'),
  paginate (meta) {
    return Utils.paginate(this.url, meta)
  },
  get (id) {
    return Vue.http.get(this.url + '/' + id)
  },
  create (data) {
    return Vue.http.post(this.url, data)
  },
  import (data) {
    return Vue.http.post(this.url + '/import', data)
  },
  update (data) {
    return Vue.http.put(this.url + '/' + data.id, data)
  },
  remove (id) {
    return Vue.http.delete(this.url + '/' + id)
  },
  getExportUrl (separator, groups) {
    const path = Utils.serialize({
      separator,
      groups
    })
    return Vue.http.get(this.url + '/export/url' + '?' + path)
  },
  statuses () {
    return [{
      id: 1,
      name: 'Aktywna'
    }, {
      id: 2,
      name: 'Nie aktywna'
    }]
  },
  separators () {
    return [{
      id: '\t',
      name: 'Tabulator'
    }, {
      id: ';',
      name: 'Średnik'
    }, {
      id: '|',
      name: 'znak "|"'
    }]
  },
  getBaseItem () {
    return {
      id: null,
      email: '',
      status: 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Emails.js